import React from 'react';
import './what-to-expect-styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRocket,
  faStar,
  faHandshake,
} from '@fortawesome/free-solid-svg-icons';
export const WhatToExpect = () => {
  return (
    <section className='expect-section'>
      <div className='expect-container'>
        <h2 className='expect-heading bar'>What You Can <span className='text-theme head-font'>Expect</span> </h2>
        <p className='expect-intro mb-0'>
          This series is more than just training—it's an engaging platform where
          our Operations and IT teams will come together to:
        </p>
        <p className='expect-intro mb-3 mt-0'>
          Whether you're a seasoned expert or just getting started, these
          sessions are for everyone looking to stay ahead of the curve and play
          an active role in our journey towards excellence.
        </p>
        <ul className='expect-list'>
          <li>
            <FontAwesomeIcon icon={faRocket} className='icon feature-icon' />
            <h4 className='expect-title'>Tech-Driven Transformation</h4>
            Unveil new features and technologies that are revolutionizing the
            way we work
          </li>
          <li>
            <FontAwesomeIcon icon={faStar} className='icon success-icon' />
            <h4 className='expect-title'>Spotlight on Success</h4>
            Showcase success stories from your fellow colleagues, including
            guest speakers from clinical and operational teams
          </li>
          <li>
            <FontAwesomeIcon
              icon={faHandshake}
              className='icon collaboration-icon'
            />
            <h4 className='expect-title'>Collaborate & Innovate</h4>
            Offer a space for collaboration, where you can ask questions,
            provide feedback, and share your insights on how we can continue to
            enhance our work processes
          </li>
        </ul>

       
      </div>
    </section>
  );
};
